import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { WarehouseModule } from './warehouse/warehouse.module';
import { StockInEntity } from './warehouse/stock-in.entity';
import {appSettings} from '../../../config';
import { StockOut } from './warehouse/stock-out.entity';
import { Stock } from './warehouse/stock.entity';
import { ProductionCostAnalysisEntity } from './warehouse/production-cost-analysis.entity';
import { RMPurchaseAnalysisEntity } from './warehouse/rm_purchase_analysis.entity';
import { CronInfo } from './warehouse/cron-info.entity';
import { DaywiseOpeningStockEntity } from './warehouse/daywise-opening-stock.entity';
import { DaywiseShrimpAnalysisEntity } from './warehouse/daywise-shrimp-analysis.entity';
import { MontlyMisEntity } from './warehouse/montly-mis.entity';
import { MainDashboardModule } from './dashboard/main-dashboard.module';
import { BaleAmtInfo } from './warehouse/bale-amt-info.entity';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
    // host: '142.93.219.119',
    host: appSettings.dbhost,
    port: 3306,
    username: appSettings.dbuser,
    password: appSettings.dbpassword,
    database: appSettings.analytics_db,
      entities: [StockInEntity,StockOut,Stock,ProductionCostAnalysisEntity,RMPurchaseAnalysisEntity,CronInfo,DaywiseOpeningStockEntity,DaywiseShrimpAnalysisEntity,MontlyMisEntity,BaleAmtInfo],
      synchronize: false,
      logging: true
  }),
    WarehouseModule,MainDashboardModule

  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
